import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useGetJsonByApplicationNLang from "../../../lms-shared/hooks/useGetJsonByApplicationNLang";
import Collapse from "../../../UI/Collapse/Collapse";
import classes from "./FAQ.module.css";

const FAQ = () => {

    const texts = useSelector(state => state.translate.texts);
    const [FAQ, setFAQ] = useState()
    useGetJsonByApplicationNLang('faq', res => res && setFAQ(res.faq))

    return (
        <div className={classes.FAQContainer}>
            <div className={classes.AllQuestionAndAnswer}>
                {FAQ && FAQ.map((f,index) => <div key={index}>
                    
                    <p className={classes.TitleContent}>{f.title}</p>
                    <div className={classes.Line}></div>
                    {f.content && f.content.map((c,index2) => <Collapse key={index2} title={c.question} content={c.answer}></Collapse>)}
                </div>
                )}
            </div>
        </div>
    )
}
export default FAQ